import { LsCartThumb } from '@/components/ls-cart-thumb/LsCartThumb';
import type { CartItem } from '@/features/cart/cart.store';
import { COPY } from '@/shared/content/copy';
import { formatRub } from '@/shared/lib/money';
import styles from './ls-line-item.module.scss';

interface Props {
  item: CartItem;
  onQtyChange: (qty: number) => void;
  onRemove: () => void;
}

/** Позиция заказа: используется и в корзине, и на экране оформления. */
export function LsLineItem({ item, onQtyChange, onRemove }: Props) {
  return (
    <li className={styles['ls-line-item']}>
      <span className={styles['ls-line-item__media']}>
        <LsCartThumb item={item} />
      </span>

      <div className={styles['ls-line-item__info']}>
        <div className={styles['ls-line-item__row']}>
          <span className={styles['ls-line-item__name']}>{item.title}</span>
          <span className={styles['ls-line-item__price']}>
            {formatRub(item.unitPriceRub * item.qty)}
          </span>
        </div>

        <span className={styles['ls-line-item__size']}>
          {COPY.cart.size}: {item.size}
        </span>

        <div className={styles['ls-line-item__qty']}>
          <button
            className={styles['ls-line-item__step']}
            type="button"
            // Меньше одной штуки позиции не бывает: убрать её целиком —
            // это «Удалить» рядом. Кнопка, которая на единице просто
            // не срабатывала, выглядела сломанной.
            disabled={item.qty <= 1}
            onClick={() => onQtyChange(item.qty - 1)}
            aria-label={COPY.cart.decrease}
          >
            <img className={styles['ls-line-item__step-icon']} src="/ui/minus.svg" alt="" />
          </button>

          <span className={styles['ls-line-item__count']}>{item.qty}</span>

          <button
            className={styles['ls-line-item__step']}
            type="button"
            onClick={() => onQtyChange(item.qty + 1)}
            aria-label={COPY.cart.increase}
          >
            <img className={styles['ls-line-item__step-icon']} src="/ui/plus.svg" alt="" />
          </button>
        </div>

        <button className={styles['ls-line-item__remove']} type="button" onClick={onRemove}>
          {COPY.cart.remove}
        </button>
      </div>
    </li>
  );
}
